import { Plugin, PluginKey } from '@tiptap/pm/state';
import { DecorationSet } from '@tiptap/pm/view';

/*
 * Shared diff-decorations leaf. Consumed by thin `Extension.create` twins in
 * each editor system — the twins are never mounted together, so a single
 * plugin key is safe.
 */

export const DIFF_PLUGIN_KEY = new PluginKey('diffDecorations');

/**
 * ProseMirror plugin that holds diff decoration state. Decorations are
 * updated by dispatching transactions with `DIFF_PLUGIN_KEY` metadata
 * containing a `DecorationSet`; any other doc-changing transaction clears
 * them.
 */
export function createDiffDecorationsPlugin(): Plugin {
  return new Plugin({
    key: DIFF_PLUGIN_KEY,
    state: {
      init: () => DecorationSet.empty,
      apply: (tr, value) => {
        const meta = tr.getMeta(DIFF_PLUGIN_KEY) as DecorationSet | undefined;
        if (meta !== undefined) return meta;
        if (tr.docChanged) return DecorationSet.empty;
        return value;
      },
    },
    props: {
      decorations(state) {
        return DIFF_PLUGIN_KEY.getState(state) as DecorationSet;
      },
    },
  });
}
